import { useEffect } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import "@fontsource-variable/lora/wght.css";
import "@fontsource-variable/lora/wght-italic.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { startLenis, scrollTop } from "@/lib/lenis";
import Home from "@/pages/Home";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/admin/Admin";
import ContactPage from "@/pages/ContactPage";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

const RouteTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) scrollTop();
  }, [pathname, hash]);
  return null;
};

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <RouteTop />
      {!isAdmin && <Nav />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
    </>
  );
};

function App() {
  useEffect(() => {
    const stop = startLenis();
    return () => stop();
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#16302B", color: "#fff", border: "1px solid #B8874A", borderRadius: 0, fontFamily: "Poppins, sans-serif" } }} />
    </MotionConfig>
  );
}

export default App;
